import React from 'react';

const PartFPage2 = ({ data }) => {
  const skills = data?.skills || Array(4).fill({ skill_name: '', hours: 0, pursuing: false, completed: false });

  const getTotalHours = () => {
    return skills.reduce((sum, skill) => sum + (skill.hours || 0), 0);
  };

  const rowLabels = ['a', 'b', 'c', 'd'];

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      margin: '0 auto',
      padding: '20mm',
      backgroundColor: 'white',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      position: 'relative',
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #FF8C42 transparent transparent'
      }} />

      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: '2px solid #888',
        marginBottom: '30px'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#F4CD8A' }}>
            <th colSpan={5} style={{
              padding: '10px 8px',
              textAlign: 'left',
              fontWeight: 'bold',
              fontSize: '12px',
              color: '#333',
              border: '1px solid #888'
            }}>
              4. Learning in the Community (Skill Training)
            </th>
          </tr>
          <tr style={{ backgroundColor: '#F4E4B8' }}>
            <th style={{
              width: '50px',
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'normal',
              color: '#333',
              border: '1px solid #888',
              backgroundColor: '#FFF9E6'
            }}></th>
            <th style={{
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Skill
            </th>
            <th style={{
              width: '120px',
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Number of Hours
            </th>
            <th style={{
              width: '100px',
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Pursuing
            </th>
            <th style={{
              width: '100px',
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Completed (✓)
            </th>
          </tr>
        </thead>
        <tbody>
          {skills.slice(0, 4).map((skill, index) => (
            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#FFFEF8' : '#FFF9E6' }}>
              <td style={{
                padding: '8px',
                textAlign: 'center',
                fontSize: '12px',
                color: '#333',
                border: '1px solid #888',
                fontWeight: 'bold'
              }}>
                {rowLabels[index]})
              </td>
              <td style={{
                padding: '8px',
                fontSize: '12px',
                color: '#333',
                border: '1px solid #888'
              }}>
                {skill.skill_name || '-'}
              </td>
              <td style={{
                padding: '8px',
                fontSize: '12px',
                color: '#333',
                border: '1px solid #888',
                textAlign: 'center'
              }}>
                {skill.hours || 0}
              </td>
              <td style={{
                padding: '8px',
                fontSize: '12px',
                color: '#333',
                border: '1px solid #888',
                textAlign: 'center'
              }}>
                {skill.pursuing ? '✓' : ''}
              </td>
              <td style={{
                padding: '8px',
                fontSize: '12px',
                color: '#333',
                border: '1px solid #888',
                textAlign: 'center'
              }}>
                {skill.completed ? '✓' : ''}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{ backgroundColor: '#F4E4B8' }}>
            <td style={{
              padding: '10px',
              border: '1px solid #888'
            }}></td>
            <td style={{
              padding: '10px',
              textAlign: 'right',
              fontWeight: 'bold',
              fontSize: '14px',
              color: '#333',
              border: '1px solid #888'
            }}>
              Total Hours
            </td>
            <td style={{
              padding: '10px',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
              color: '#333',
              border: '1px solid #888'
            }}>
              {getTotalHours()}
            </td>
            <td style={{
              padding: '10px',
              border: '1px solid #888'
            }}></td>
            <td style={{
              padding: '10px',
              border: '1px solid #888'
            }}></td>
          </tr>
        </tfoot>
      </table>

      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '12px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        40
      </div>

      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #FF8C42'
      }} />

      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '50px 50px 0 0',
        borderColor: 'transparent #FFB347 transparent transparent',
        opacity: 0.5
      }} />
    </div>
  );
};

export default PartFPage2;
